import {ControlValueAccessor} from "@angular/forms";
import _cloneDeep from "lodash/cloneDeep";

export class BaseFormControlComponent<TValueType> implements ControlValueAccessor {
    private _value: TValueType;

    protected get value(): TValueType {
        return _cloneDeep(this._value);
    }

    private _disabled: boolean = false;

    protected get disabled(): boolean {
        return this._disabled;
    }

    private _onChange: any = () => {};

    private _onTouched: any = () => {};

    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     */
    public registerOnChange(fn: () => void): void {
        this._onChange = fn;
    }

    /**
     * Registers a callback function that is called by the forms API on initialization to update the form model on blur.
     */
    public registerOnTouched(fn: () => void): void {
        this._onTouched = fn;
    }

    /**
     * Function that is called by the forms API when the control status changes to or from "DISABLED".
     */
    public setDisabledState(disabled: boolean): void {
        this._disabled = disabled;
    }

    /**
     * Writes a new value to the element.
     */
    public writeValue(value: any): void {
        this._value = value;
    }

    protected writeNewValue(value: TValueType): void {
        if (value !== undefined) {
            this.writeValue(value);
            this._onChange(value);
        }
    }
}
